import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/anime';

const featuredArticles = articles.filter((a) => a.isFeatured);

const articleImages: Record<string, string> = {
  '1': 'https://readdy.ai/api/search-image?query=Death%20Note%20anime%20art%20style%2C%20dark%20atmosphere%2C%20a%20mysterious%20black%20notebook%20on%20a%20wooden%20desk%20with%20a%20single%20candle%20casting%20dramatic%20shadows%2C%20gothic%20aesthetic%2C%20deep%20crimson%20and%20black%20tones%2C%20minimalist%20composition%2C%20high%20contrast&width=400&height=560&seq=death-note-card&orientation=portrait',
  '2': 'https://readdy.ai/api/search-image?query=Attack%20on%20Titan%20anime%20epic%20style%2C%20a%20lone%20soldier%20with%20cape%20facing%20a%20massive%20colossal%20figure%20in%20the%20distance%2C%20golden%20sunset%20sky%2C%20dramatic%20scale%2C%20warm%20amber%20lighting%2C%20cinematic%20atmosphere%2C%20powerful%20silhouette&width=400&height=560&seq=aot-card-2026&orientation=portrait',
  '3': 'https://readdy.ai/api/search-image?query=Psycho%20Pass%20anime%20futuristic%20style%2C%20a%20sleek%20holographic%20interface%20displaying%20a%20glowing%20crime%20coefficient%20number%20in%20a%20dark%20surveillance%20room%2C%20neon%20amber%20accents%2C%20cold%20metallic%20surfaces%2C%20cyberpunk%20atmosphere%2C%20clean%20minimalist%20composition&width=400&height=560&seq=psycho-pass-card&orientation=portrait',
  '4': 'https://readdy.ai/api/search-image?query=Monster%20anime%20psychological%20thriller%20style%2C%20a%20hospital%20corridor%20at%20night%20with%20dim%20flickering%20lights%2C%20a%20single%20shadowy%20figure%20standing%20at%20the%20far%20end%2C%20cold%20atmosphere%2C%20deep%20shadows%2C%20ominous%20mood%2C%20high%20tension&width=400&height=560&seq=monster-card&orientation=portrait',
  '11': 'https://readdy.ai/api/search-image?query=Mushishi%20anime%20ethereal%20style%2C%20a%20solitary%20traveler%20with%20white%20hair%20walking%20through%20a%20misty%20bamboo%20forest%2C%20soft%20diffused%20light%20filtering%20through%20leaves%2C%20luminous%20floating%20particles%2C%20serene%20atmosphere%2C%20watercolor%20texture%2C%20gentle%20green%20and%20gold%20tones&width=400&height=560&seq=mushishi-card&orientation=portrait',
  '12': 'https://readdy.ai/api/search-image?query=Showa%20Genroku%20Rakugo%20Shinju%20anime%20traditional%20style%2C%20a%20kimono-clad%20storyteller%20kneeling%20on%20a%20tatami%20stage%20with%20a%20folding%20fan%20under%20warm%20lantern%20light%2C%20traditional%20Japanese%20theater%20setting%2C%20golden%20amber%20lighting%2C%20elegant%20composition&width=400&height=560&seq=rakugo-card&orientation=portrait',
};

export default function FeaturedList() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            {t('section.featured')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {t('section.featured.desc')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 transition-all hover:border-primary-300"
            >
              <div className="relative w-full h-[320px] md:h-[360px] overflow-hidden">
                <img
                  src={articleImages[article.id] || ''}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 flex items-center gap-1 bg-background-900/80 text-accent-400 px-2.5 py-1 rounded-md text-xs font-bold">
                  <i className="ri-star-fill"></i>
                  {article.rating}
                </div>
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                  <span className="inline-block bg-accent-500 text-background-50 text-xs px-2 py-0.5 rounded-md mb-2">
                    {article.category}
                  </span>
                  <h3 className="text-lg font-heading font-bold text-background-50">
                    {article.title}
                  </h3>
                </div>
              </div>
              <div className="p-4">
                <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed">
                  {article.synopsis.slice(0, 100)}...
                </p>
                <div className="flex items-center gap-4 mt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-film-line"></i>
                    {article.episodes}
                  </span>
                  <span>{article.year}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}